const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-check-group",
        label: "구분",
        value: "checkDatas",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "배치 전 검진", value: "배치 전 검진" },
            { text: "배치 후 검진", value: "배치 후 검진" },
            { text: "일반 검진", value: "일반 검진" },
            { text: "특수 검진", value: "특수 검진" },
          ],
          selectMaxCount: 4,
          default: [],
        },
      },
      { component: "empty-space" },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "구분", "첨부", "대상인원수", "실시인원수"], keywordInputLong: true },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({ key: "header.year", operator: "IN", value: `${year}` });

    // CheckDatas
    if (search.checkDatas) {
      for (const value of search.checkDatas) {
        conditions.push({ key: "body.구분[%]", operator: "LIKE", value: `%${value}%` });
      }
    }

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({ key: "body.subInfo.구분", operator: "=", value: search.half[0] });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.구분",
      },
      {
        name: "대상인원수",
        key: "body.대상인원수",
      },
      {
        name: "실시인원수",
        key: "body.실시인원수",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).구분.join(", "); // 구분
        case 3:
          return func.getContent(value).대상인원수; // 대상인원수
        case 4:
          return func.getContent(value).실시인원수; // 실시인원수
        case 5:
          return func.getContent(value).stdInfo.section; // 부서명
        case 6:
          return func.getContent(value).stdInfo.department; // 소속명
        case 7:
          return func.getCreatedDate(value.created_at); // 작성일
        case 8:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
};
export default list;
